export default {
    SET_SYSTEM_LOGS: (state, logs) => {
        state.systemLogs = logs
    },

    SET_TYPES: (state, types) => {
        state.types = types
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_SYSTEM_LOGS: (state) => {
        state.filters = {
            fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            email: null,
            types: []
        }
    }
}
